import {observer} from "mobx-react";
import {Linq, Page, PageContentTitle, Pager, ScrollTable, Searchbar} from "../../ui";
import {scaOverviewStore} from "../../../store";
import {useNavigate} from "react-router";
import {dateFormat} from "../../../utils";
import {convertScaStatus} from "../../../api";
import {ScaFilterBar} from "./ScaFilterBar";

const ScaOverviewPage = observer(function ScaOverviewPage() {
    const navigate = useNavigate()
    const display = 'Neue Sicherheitscodes erfassen'

    return <Page
        breadcrumb={[
            {
                link: '/sca',
                label: `Sicherheitscodes`
            },
        ]}
        actions={[
            {
                label: display,
                action: () => navigate('/sca/create'),
                icon: 'add'
            }
        ]}
    >
        <PageContentTitle
            actionItem={<>
                <ScaFilterBar/>
            </>}
        >
            <Searchbar placeholder={"FIN"}/>
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kunde</th>
                <th>Fahrzeug</th>
                <th>Kennung</th>
                <th>Datum</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            {scaOverviewStore.items.map((val, index) => {
                const link = `/sca/${val.id}`
                return <tr key={index} onClick={(e) => {
                    e.preventDefault()
                    navigate(link
                    )}}>
                    <td><Linq to={`${link}`}>{val.customer || val.customerId}</Linq></td>
                    <td><Linq to={`${link}`}>{val.vin}</Linq></td>
                    <td><Linq to={`${link}`}>{val.externalReference}</Linq></td>
                    <td><Linq to={`${link}`}>{dateFormat(val.createdDate)}</Linq></td>
                    <td><Linq to={`${link}`}>{convertScaStatus(val.status)}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={scaOverviewStore.pages} />
    </Page>
})

export {
    ScaOverviewPage
}
